class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', this.isOpen());
    if (this.classList.contains('am-header-search-modal')) {
      this.classList.add('am-motion-ready');
      this.searchBreakpoint = window.matchMedia('(min-width: 990px)');
      this.onBreakpointChange = (event) => { if (event.matches && this.isOpen()) this.close(false); };
      this.searchBreakpoint.addEventListener('change', this.onBreakpointChange);
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() && !this.detailsContainer.classList.contains('am-panel-closing') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    clearTimeout(this.closeTimer);
    cancelAnimationFrame(this.openFrame);
    this.detailsContainer.classList.remove('am-panel-closing');
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    if (this.classList.contains('am-motion-ready')) {
      this.querySelector('.search-modal').getBoundingClientRect();
      this.openFrame = requestAnimationFrame(() => this.detailsContainer.classList.add('am-search-opening'));
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.detailsContainer.classList.contains('am-panel-closing')) return;
    cancelAnimationFrame(this.openFrame);
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    if (this.classList.contains('am-motion-ready') && this.isOpen()) {
      this.detailsContainer.classList.add('am-panel-closing');
      this.detailsContainer.classList.remove('am-search-opening');
      this.summaryToggle.setAttribute('aria-expanded', false);
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 0 : parseFloat(getComputedStyle(this).getPropertyValue('--am-panel-exit')) || 220;
      this.closeTimer = setTimeout(() => this.finishClose(), duration);
      return;
    }
    this.finishClose();
  }

  finishClose() {
    this.detailsContainer.removeAttribute('open');
    this.detailsContainer.classList.remove('am-search-opening', 'am-panel-closing');
    this.summaryToggle.setAttribute('aria-expanded', false);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (!document.querySelector('cart-drawer.active, details-modal details[open], password-modal details[open], modal-dialog[open], dialog[open]')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    cancelAnimationFrame(this.openFrame);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    this.searchBreakpoint?.removeEventListener('change', this.onBreakpointChange);
    if (this.isOpen()) {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus();
    }
  }
}

customElements.define('details-modal', DetailsModal);
